export enum SocialMediaPlatform {
  Twitter = 'Twitter',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  YouTube = 'YouTube',
  X = 'X'
}